export default [{
    path: '/notification-channels',
    component: () => import('../pages/notification-channels/Index.vue'),
    children: [
        {
            path: '',
            name: 'notification-channels/list',
            meta: {
                parentPath: '/alerting',
                layout: 'default',
                breadcrumb: [{ label: 'Alerting', to: { name: 'incidents/summary' } }, { label: 'Notification Channels' }],
            },
            component: () => import('../pages/notification-channels/NotificationChannels.vue'),
        },
        {
            path: 'new',
            name: 'notification-channels/create',
            meta: {
                parentPath: '/alerting',
                layout: 'default',
                breadcrumb: [
                    { label: 'Alerting', to: { name: 'incidents/summary' } },
                    { label: 'Notification Channels', to: { name: 'notification-channels/list' } },
                    { label: 'New Notification Channel' },
                ],
            },
            component: () => import('../pages/notification-channels/NotificationChannelEdit.vue'),
        },
        {
            path: ':id',
            name: 'notification-channels/detail',
            meta: {
                parentPath: '/alerting',
                layout: 'default',
                breadcrumb: [
                    { label: 'Alerting', to: { name: 'incidents/summary' } },
                    { label: 'Notification Channels', to: { name: 'notification-channels/list' } },
                    { label: 'Notification Channel Detail' },
                ],
            },
            component: () => import('../pages/notification-channels/NotificationChannelDetail.vue'),
        },
        {
            path: ':id/edit',
            name: 'notification-channels/edit',
            meta: {
                parentPath: '/alerting',
                layout: 'default',
                breadcrumb: [
                    { label: 'Alerting', to: { name: 'incidents/summary' } },
                    { label: 'Notification Channels', to: { name: 'notification-channels/list' } },
                    { label: 'Edit Notification Channel' },
                ],
            },
            component: () => import('../pages/notification-channels/NotificationChannelEdit.vue'),
        },
    ],
}];
